import React from 'react'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Typography } from '@mui/material'
import {
  INLINE_INFO_NOTE_DEFAULT_COLORS,
  INLINE_INFO_NOTE_ICON_SX,
  INLINE_INFO_NOTE_ROOT_SX,
  INLINE_INFO_NOTE_SINGLE_LINE_MESSAGE_SX,
  INLINE_INFO_NOTE_STACKED_MESSAGE_SX,
  INLINE_INFO_NOTE_STACKED_TITLE_SX,
  INLINE_INFO_NOTE_TITLE_SX
} from './constants/inlineInfoNote'

const InlineInfoNote = ({
  title = 'Nota:',
  message,
  children,
  icon = <InfoOutlinedIcon />,
  iconColor,
  titleColor,
  textColor,
  colors = {},
  singleLine = false,
  iconSx = {},
  titleSx = {},
  messageSx = {},
  sx = {}
}) => {
  const styles = {
    ...INLINE_INFO_NOTE_DEFAULT_COLORS,
    ...(iconColor ? { iconColor } : {}),
    ...(titleColor ? { titleColor } : {}),
    ...(textColor ? { textColor } : {}),
    ...colors
  }
  const content = children ?? message

  return (
    <Box
      sx={{
        alignItems: singleLine ? 'center' : 'flex-start',
        ...INLINE_INFO_NOTE_ROOT_SX,
        ...sx
      }}
    >
      <Box
        sx={{
          color: styles.iconColor,
          mt: singleLine ? 0 : '3px',
          ...INLINE_INFO_NOTE_ICON_SX,
          ...iconSx
        }}
      >
        {icon}
      </Box>

      {singleLine ? (
        <Typography
          component="span"
          sx={{
            color: styles.textColor,
            ...INLINE_INFO_NOTE_SINGLE_LINE_MESSAGE_SX,
            ...messageSx
          }}
        >
          <Box
            component="span"
            sx={{
              color: styles.titleColor,
              ...INLINE_INFO_NOTE_TITLE_SX,
              ...titleSx
            }}
          >
            {title}
          </Box>{' '}
          {content}
        </Typography>
      ) : (
        <Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 0.5
            }}
          >
            <Typography
              sx={{
                color: styles.titleColor,
                ...INLINE_INFO_NOTE_STACKED_TITLE_SX,
                ...titleSx
              }}
            >
              {title}
            </Typography>
          </Box>

          <Typography
            sx={{
              color: styles.textColor,
              ...INLINE_INFO_NOTE_STACKED_MESSAGE_SX,
              ...messageSx
            }}
          >
            {content}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default InlineInfoNote
